import { fontService } from '../services/font.services';

export default {
  filters: {
    textLowerCase(raw) {
      return raw.toLowerCase();
    },

    zgtext(unitext) {
        return fontService.convertToZg(unitext);
    }
  }
}